'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCodeOutline = function TiCodeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13 31.7c-1.3 0-2.5-0.6-3.5-1.5l-8.5-8.5 8.5-8.6c1.9-1.9 5.2-1.9 7.1 0 1.9 2 1.9 5.2 0 7.1l-1.5 1.5 1.5 1.4c1.9 2 1.9 5.2 0 7.1-1 0.9-2.2 1.5-3.6 1.5z m-7.3-10l6.2 6.1c0.6 0.7 1.7 0.7 2.3 0 0.7-0.6 0.7-1.7 0-2.3l-3.8-3.8 3.8-3.9c0.7-0.6 0.7-1.7 0-2.3-0.6-0.6-1.7-0.6-2.3 0l-6.2 6.2z m21.3 10c-1.4 0-2.6-0.6-3.6-1.5-1.9-1.9-1.9-5.1 0-7.1l1.5-1.4-1.5-1.5c-1.9-1.9-1.9-5.1 0-7.1 1.9-1.9 5.2-1.9 7.1 0l8.5 8.6-8.5 8.5c-1 0.9-2.2 1.5-3.5 1.5z m0-16.7c-0.5 0-0.9 0.2-1.2 0.5-0.7 0.6-0.7 1.7 0 2.3l3.8 3.9-3.8 3.8c-0.7 0.6-0.7 1.7 0 2.3 0.6 0.7 1.7 0.7 2.3 0l6.2-6.1-6.2-6.2c-0.3-0.3-0.7-0.5-1.1-0.5z' })
        )
    );
};

exports.default = TiCodeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/code-outline.js
// module id = 3588
// module chunks = 0